import { getEnvVar } from 'src/lib/env'
import type { NotificationMessage } from 'src/types/modal.interfaces'

export enum MODAL_TYPE {
  APPROVAL_HISTORY_REPORT = 'APPROVAL_HISTORY_REPORT',
  BULK_COPY = 'BULK_COPY',
  BULK_EDIT = 'BULK_EDIT',
  COMPARE = 'COMPARE',
  DELETE = 'DELETE',
  FLOOR_PLAN_UPLOAD = 'FLOOR_PLAN_UPLOAD',
  MARK_AS_CORE = 'MARK_AS_CORE',
  NEW_VERSION = 'NEW_VERSION',
  PLAN = 'PLAN',
  PRINT = 'PRINT',
  PROPAGATE = 'PROPAGATE',
  PROPAGATE_FILES = 'PROPAGATE_FILES',
  RELEASE_NOTES_MODAL = 'RELEASE_NOTES_MODAL',
  SHARE = 'SHARE',
  VERSION_HISTORY = 'VERSION_HISTORY',
}

export enum MODAL_STORE_KEY {
  APPROVAL_HISTORY_REPORT = 'approvalHistoryReportModalState',
  BULK_COPY = 'bulkCommunityCopyModalState',
  BULK_EDIT = 'bulkEditModalState',
  COMPARE = 'compareModalState',
  DELETE = 'deleteModalState',
  FLOOR_PLAN_UPLOAD = 'floorPlanUploadModalState',
  MARK_AS_CORE = 'markAsCoreModalState',
  NEW_VERSION = 'newVersionModalState',
  PLAN = 'planModalState',
  PRINT = 'printModalState',
  PROPAGATE = 'propagateModalState',
  PROPAGATE_FILES = 'propagateFilesModalState',
  RELEASE_NOTES_MODAL = 'releaseNotesModalState',
  SHARE = 'shareModalState',
  VERSION_HISTORY = 'versionHistoryModalState',
}

export enum MODAL_BUTTONS {
  CANCEL = 'CANCEL',
  OK = 'OK',
  PROCEED = 'PROCEED',
}

export const PLAN_COPY = 'Plan Copy'
export const defaultPlanElevationLabel = 'Plan Elevation 1'
export const allowedPlanLength = 4
export const allowedPlanLengthForShellPlans = [3, 4]
export const allowedPlanLengthForUnitPlans = 4
export const defaultCommunityNumberLabel = 'Community Number 1'
export const defaultCommunityNameLabel = 'Community Number 1'
export const divisionalUserPopupRequestApprovalText =
  'Approval is required. Click OK to request approval.'
export const RELEASE_BANNER_VISIBILITY_DAYS =
  Number(getEnvVar('REACT_APP_RELEASE_BANNER_VISIBILITY_DAYS')) || 7
export const RELEASE_BANNER_TITLE =
  getEnvVar('REACT_APP_RELEASE_BANNER_TITLE') ||
  "🚀 New Features Released! Check Out What's New!"
export const DEFAULT_EXPORTED_FILES_SIZE =
  Number(getEnvVar('REACT_APP_EXPORTED_FILES_SIZE')) || 10

export const APPROVAL_REQUEST_SUCCESS_MESSAGE: NotificationMessage =
  'Your approval request to copy has been sent. Check Copy Approval column for status.'
export const APPROVAL_REQUEST_FAILURE_MESSAGE: NotificationMessage =
  'Your approval request to copy failed'

export const EXCEL_SHEET_FILE_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

export const UPLOAD_FLOOR_PLAN = 'Upload Floor Plan'
export const NEW_VERSION_TITLE = 'New Version Available'
export const NEW_VERSION_AVAILABLE =
  'New version of Plan Library has been released. Please refresh to use the newest version.'
export const BULK_EDIT_TITLE =
  'From the selected plans, choose a plan as the base for editing.'

export const HELP_ME_RECIPIENT = 'servicedesk@lennar.com'
export const HELP_ME_SUBJECT = 'Help Me Request'
export const HELP_ME_BODY = `Please include a detailed description, screenshots, and attachments with your Help Me Request. Use this form for feedback, issues, or enhancement requests.

Note: Plan Status and Pricing attribute changes should be managed in JDE E1, not in Plan Library.

If you encounter a bug, please provide the following information:
  • Steps to reproduce:
  • Expected behavior:
  • Actual behavior:
`

export const UPLOAD_FILE_DISABLED_TOOLTIP =
  'Enter Plan, only one Elevation and Community/Region/Division to enable file upload'
export const UPLOADED_FILE_AREA = 'Document for auto-extract'
export const UPLOAD_FILE_ERROR_TOOLTIP =
  'Please upload only PDF files for auto-extract.'
export const UPLOADED_FILE_PROCESSING_TOOLTIP =
  'Please wait up to 1 min for processing to finish.'

export const PROCEED_BUTTON_DISABLED_TOOLTIP =
  'Please add required Plan data and a document to auto-extract'

export const AUTO_EXTRACT_DOCUMENT_UPLOAD_SUCCESS =
  'Please wait up to 1 min for processing to finish. You will be notified when it’s ready.'

/**
 * The admin API's 409 bodies when a copy approval record already exists for
 * the plan and the requesting division. Each one tells the user where the
 * request stands, so the approval dialog treats them as answers, not errors.
 */
export const COPY_APPROVAL_ALREADY_GRANTED_MESSAGE = 'Approval already granted'
export const COPY_APPROVAL_ALREADY_DENIED_MESSAGE = 'Approval already denied'
export const COPY_APPROVAL_REQUEST_ALREADY_EXISTS_MESSAGE =
  'Approval request already exists'

export const COPY_REQUEST_PENDING_APPROVAL_MESSAGE =
  'Request for copy is pending for approval'
export const COPY_REQUEST_REJECTED_FOR_MESSAGE =
  'Request for copy was rejected for'
export const COPY_REQUEST_ERROR_MESSAGE = 'Error in making request'
export const APPROVAL_REQUEST_FAILED_FOR_PLANS_MESSAGE = (
  planNames: string,
  reason?: string
): string =>
  `Your approval request to copy failed for ${planNames}${
    reason ? `: ${reason}` : ''
  }`
export const COPY_APPROVAL_DENIED_FOR_PLANS_MESSAGE = (
  planNames: string
): string => `${COPY_REQUEST_REJECTED_FOR_MESSAGE} ${planNames}`

export const BULK_COPY_FAILURE_MESSAGE =
  'something went wrong while copying the plans'
export const COMMUNITY_LOOKUP_FAILURE_MESSAGE =
  'Failed to Fetch the Community Name'
export const UNABLE_TO_DETERMINE_REGION_MESSAGE =
  'Unable to determine region of user'
